const scroll = (e, menuElement) => {
	
	const threshhold = 200
	const position = window.scrollY || window.pageYOffset
	const className = "menu--minimal"
	
	if (position > threshhold) {
		menuElement.classList.add(className)
	} else {
		menuElement.classList.remove(className)
	}
	
}

const mobileToggle = e => {

	e.preventDefault()
	
	const className = "menu__expanded"
	const menu = document.querySelector('.menu')
	menu.classList.toggle(className)

}

const menu = () => {
	
	// Compact mode
	// const menuElement = document.querySelector('.menu')
	// window.addEventListener('scroll', () => scroll(event, menuElement))
	
	// Mobile
	const mobileButton = document.querySelector('.js-mobiletoggle')
	mobileButton.addEventListener('click', mobileToggle)
	
}

export default menu
